module.exports = __webpack_public_path__ + "images/2.1787648603550.jpg";